// 系统接口地址
import request from "@/utils/request"

// 获取版本信息
export const versionInfo = function() {
  return request('get', '/api/project/version')
}

// 获取登录用户信息
export const userInfo = function() {
  return request('get', '/api/user/self')
}

// 版权信息
export const copyright = function() {
  return request('get', '/api/project/copyright')
}

// 修改密码
export const modifyPassword = function(params) {
  return request('post', '/api/user/pwd', params)
}

// 获取字典
export const getDicts = function(type = []) {
  return request('get', '/api/common/getSysOptions', { type })
}

// 获取轮播图
export const getBanners = function(query = {}) {
  return request('get', '/api/common/getBanner', query)
}

// 获取扫码规则
export const getCodeRules = function() {
  return request('get', '/api/common/encodeRule')
}

//个人中心
export const getUserCenter = function(silence = false) {
  return request('get','/api/user/center', {}, { silence })
}